import { FC, LabelHTMLAttributes } from 'react';

export const FieldLabel2: FC<LabelHTMLAttributes<HTMLLabelElement>> = ({ className = '', ...labelProps }) => {
  return <label className={`mb-1 flex font-bold leading-5 text-dark ${className}`} {...labelProps} />;
};
